export default class SignOutController {
  /* @ngInject */
  constructor(SecurityManager, $state, $rootScope) {
    SecurityManager.signout(() => {
      $state.go("login");
    });
  }
}
